var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{style:(_vm.end == Object.keys(_vm.data).pop() || _vm.value == Object.keys(_vm.data).pop()
      ? { 'text-align': 'right' }
      : { 'text-align': 'left' }),attrs:{"colspan":_vm.end == Object.keys(_vm.data).pop() || _vm.value == Object.keys(_vm.data).pop() ? 2 : 1},domProps:{"innerHTML":_vm._s(isNaN(_vm.value) ? _vm.clearCase(_vm.value) : _vm.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }